import React from 'react';
import { observer } from 'mobx-react-lite';
import ChatWSComponent from '@/components/chat-ws';
import SettingComponent from '@/components/chat-ws/setting';
import ClientHeader from '@/components/client/header';
import wsStore from '@/components/chat-ws/store';
import { useEffect } from 'react';
import userStore from '@/store/user';

const ChatWS = observer((props) => {
  useEffect(() => {
    wsStore.loadLastChat();
  }, []);

  if(!userStore.isReady){
    return null;
  }
  if(!wsStore.currentStore){
    return null;
  }

  return (
    <div className='h-full flex flex-col items-center'>
      <ClientHeader />
      <div className="h-0 flex-grow flex flex-col w-full">
        <ChatWSComponent />
        <SettingComponent />
      </div>
    </div>

  )
});
export default ChatWS;
